import React from 'react';

export default function ErrorState({ message = 'Something went wrong.', onRetry }) {
  return (
    <div className="mol-error-state">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <p className="mol-error-state__message">{message}</p>
      {onRetry && (
        <button className="mol-btn mol-btn--secondary mol-btn--sm" onClick={onRetry}>
          Try Again
        </button>
      )}
    </div>
  );
}
